export default __webpack_public_path__ + "static/media/277.7db92df3.jpg";